import styled from 'styled-components';

interface Props {
  isMobile?: boolean,
}

const CaseWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 30px;
  margin-bottom: 60px;
`;

const CaseImage = styled.img`
  width: 90%;
  display: ${(props: Props) => props.isMobile ? 'none' : 'block'};

  @media only screen and (max-width: 767px) {
    width: 80%;
    display: ${(props: Props) => props.isMobile ? 'block' : 'none'};
  }
`;

export {
  CaseWrapper,
  CaseImage,
};
